import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import useAccessLevels from "../../../../../hooks/use-access-levels";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import AnalyticsLostSearchLogsView from "./lost-sales-logs";
import AnalyticsLookupLogsView from "./lookup-logs";

const AnalyticsLogsViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();

    /**
     * Checks the pathname of the url with each change of the url.
     * if the pathname was [accounting.base] then redirects the user to the credits view.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.analytics.logs.base, exact: true})) {
            if (operatorAccessLevels.packages.dashboard.lookupLogs) {
                history.replace(routes.analytics.logs.lookup);
            } else if (operatorAccessLevels.packages.dashboard.lostSalesLogs) {
                history.replace(routes.analytics.logs.lostSales);
            } else {
                history.replace(routes.analytics.logs.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.dashboard.lookupLogs, operatorAccessLevels.packages.dashboard.lostSalesLogs])

    return (
        <>
            <Switch>
                <Route path={routes.analytics.logs.base} exact/>
                {
                    operatorAccessLevels.packages.dashboard.lookupLogs &&
                    <Route path={routes.analytics.logs.lookup} exact>
                        <AnalyticsLookupLogsView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.dashboard.lostSalesLogs &&
                    <Route path={routes.analytics.logs.lostSales} exact>
                        <AnalyticsLostSearchLogsView/>
                    </Route>
                }
                <Redirect to={routes.analytics.logs.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>
        </>

    );
};

export default AnalyticsLogsViews;
